import React, { useState } from 'react'
import {
  TableRow,
  TableCell,
  TableBody,
  Table,
  TableHead,
  TableContainer,
} from '@material-ui/core'
import Pagination from '../../Pagination/Pagination'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import { MoreVert } from '@material-ui/icons'

const MachineTable = ({
  machines,
  setMachineToEdit,
  setShowAddEditMachine,
  setMachineToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const Row = ({ machine }) => {
    const handleEditMachine = () => {
      setMachineToEdit(machine)
      setShowAddEditMachine(true)
    }

    const handleDeleteMachine = () => {
      setShowDeleteModal(true)
      setMachineToDelete(machine)
    }

    return (
      <TableRow>
        <TableCell>{machine.name}</TableCell>
        <TableCell>{machine.serialNum}</TableCell>
        <TableCell>{machine.model}</TableCell>
        <TableCell>{machine.toolChanger ? 'Yes' : 'No'}</TableCell>
        <TableCell>
          {useDateFormatter(machine.createdAt, 'MM-DD-YYYY')}
        </TableCell>
        <TableCell>
          {useDateFormatter(machine.updatedAt, 'MM-DD-YYYY')}
        </TableCell>
        <TableCell>
          <ActionsMenu
            icon={<MoreVert />}
            options={[
              { onClick: handleEditMachine, label: 'Edit' },
              { onClick: handleDeleteMachine, label: 'Delete' },
            ]}
          />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Serial number</TableCell>
              <TableCell>Model</TableCell>
              <TableCell>Tool changer</TableCell>
              <TableCell>Date added</TableCell>
              <TableCell>Last updated</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? machines.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : machines
            ).map((machine, index) => (
              <Row key={index} machine={machine} />
            ))}
          </TableBody>
        </Table>
        <Pagination
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          rows={machines}
        />
      </TableContainer>
    </>
  )
}

export default MachineTable
